














import Vue from "vue";

export default Vue.extend({
  name: "App",
  data: () => ({
    apps: [
      {
        name: "たちみどろいど",
        description: "ニコ生の全部屋見れるコメビュ",
        platform: "Android",
        icon: "android",
        link:
          "https://play.google.com/store/apps/details?id=io.github.takusan23.tatimidroid"
      },
      {
        name: "つりとーも",
        description: "つりっくまのパクリゲー",
        platform: "Web系",
        icon: "web",
        link: "https://game.nicovideo.jp/atsumaru/games/gm13544?link_in=users"
      },
      {
        name: "NicoruCountFix",
        description: "ニコるくん9+直す拡張機能",
        platform: "Chrome Extension",
        icon: "extension",
        link:
          "https://chrome.google.com/webstore/detail/nicorucountfix/hfjbbhoeogmcfembakhiekefakkplbie?hl=ja"
      }
    ]
  }),
  methods: {
    open(link: string): void {
      window.open(link);
    }
  },
});
